
export const FilterOperator = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8
} as const;

export type FilterOperator = typeof FilterOperator[keyof typeof FilterOperator];

export const SortType = {
  NUMBER_0: 0, 
  NUMBER_1: 1  
} as const;

export type SortType = typeof SortType[keyof typeof SortType];

export interface FieldFilter {
  filterField?: string | null;
  filterValue?: string | null;
  filterOperator?: FilterOperator;
}

export interface BidBaseGetQuery {
  take?: number | null;
  offset?: number;
  sortBy?: string | null;
  sort?: SortType;
  filters?: any;
}

export interface RegionBaseGetQuery {
  take?: number | null;
  offset?: number;
  sortBy?: string | null;
  sort?: any;
  filters?: Array<FieldFilter> | null;
}

export interface CropBaseGetQuery {
  take?: number | null;
  offset?: number;
  sortBy?: string | null;
  sort?: any;
  filters?: Array<FieldFilter> | null;
}

export interface BidTypeBaseGetQuery {
  take?: number | null;
  offset?: number;
  sortBy?: string | null;
  sort?: any;
  filters?: Array<FieldFilter> | null;
}

export interface ApiBid {
  id?: string;
  bidTypeId?: string;
  bidStateId?: string;
  foremanId?: string | null;
  workerId?: string | null;
  startDate?: string | null;
  deadlineDate?: string | null;
  endDate?: string | null;
  fieldId?: string | null;
  regionId?: string | null;
  cropId?: string | null;
  varietyId?: string | null;
  comment?: string | null;
  description?: string | null;
  lat?: number | null;
  lng?: number | null;
  fieldPlantingDate?: string | null;
  customer?: string | null;
  fileResultId?: string | null;
  bidTemplateId?: string;
}